function clone(value) {
  return JSON.parse(JSON.stringify(value))
}

function hasBrokenText(value) {
  if (typeof value === 'string') return /\{2,}/.test(value) || value.includes('\uFFFD')
  if (Array.isArray(value)) return value.some(hasBrokenText)
  if (value && typeof value === 'object') return Object.values(value).some(hasBrokenText)
  return false
}

function mergeContent(defaultValue, remoteValue) {
  if (hasBrokenText(remoteValue)) return defaultValue
  if (Array.isArray(defaultValue)) {
    if (!Array.isArray(remoteValue)) return defaultValue
    if (!defaultValue.length) return clone(remoteValue)
    return defaultValue.map((defaultItem, index) => {
      return remoteValue[index] === undefined ? defaultItem : mergeContent(defaultItem, remoteValue[index])
    })
  }
  if (defaultValue && typeof defaultValue === 'object') {
    const result = { ...defaultValue }
    if (!remoteValue || typeof remoteValue !== 'object' || Array.isArray(remoteValue)) return result
    Object.keys(remoteValue).forEach(key => {
      result[key] = defaultValue[key] === undefined ? remoteValue[key] : mergeContent(defaultValue[key], remoteValue[key])
    })
    return result
  }
  return remoteValue === undefined ? defaultValue : remoteValue
}

export function extractDataSnapshot(db) {
  return {
    version: db.version,
    languages: db.languages || ['ua', 'ru', 'en'],
    categories: clone(db.categories || {}),
    general: {
      sections: (((db.general || {}).sections) || []).map(section => ({
        key: section.key,
        content: clone(section.content || {})
      }))
    },
    pages: Object.fromEntries(Object.entries(db.pages || {}).map(([pageKey, page]) => [
      pageKey,
      {
        sections: (page.sections || []).map(section => ({
          key: section.key,
          content: clone(section.content || {})
        }))
      }
    ])),
    collections: Object.fromEntries(Object.entries(db.collections || {}).map(([collectionKey, collection]) => [
      collectionKey,
      {
        items: clone(collection.items || [])
      }
    ]))
  }
}

export function mergeDataSnapshots(defaultData, remoteData) {
  if (!remoteData) return defaultData

  const merged = clone(defaultData)
  merged.categories = {
    ...(defaultData.categories || {}),
    ...((remoteData && remoteData.categories) || {})
  }

  merged.general.sections = (defaultData.general.sections || []).map(section => {
    const remoteSection = ((remoteData.general || {}).sections || []).find(item => item.key === section.key)
    return remoteSection ? { ...section, content: mergeContent(section.content, remoteSection.content) } : section
  })

  Object.keys(defaultData.pages || {}).forEach(pageKey => {
    const remotePage = remoteData.pages && remoteData.pages[pageKey]
    if (!remotePage) return
    merged.pages[pageKey].sections = (merged.pages[pageKey].sections || []).map(section => {
      const remoteSection = (remotePage.sections || []).find(item => item.key === section.key)
      return remoteSection ? { ...section, content: mergeContent(section.content, remoteSection.content) } : section
    })
  })

  Object.keys(defaultData.collections || {}).forEach(collectionKey => {
    const remoteCollection = remoteData.collections && remoteData.collections[collectionKey]
    if (!remoteCollection || !Array.isArray(remoteCollection.items)) return
    merged.collections[collectionKey].items = remoteCollection.items
  })

  return merged
}
